import gsap from "../gsap";

export class Subscribable {
  #subscribers = [];

  subscribe(fn, priority = 5, id = Symbol()) {
    const subscriber = { fn, id, priority };
    const index = this.#subscribers.findIndex(
      (sub) => sub.priority <= priority
    );

    if (index === -1) {
      this.#subscribers.push(subscriber);
    } else {
      this.#subscribers.splice(index, 0, subscriber);
    }

    return () => this.#unsubscribe(id);
  }

  #unsubscribe(id) {
    this.#subscribers = this.#subscribers.filter(
      (subscriber) => subscriber.id !== id
    );
  }

  set subs(value) {
    this.#subscribers.forEach((subscriber) => subscriber.fn(value));
  }
}

class _Resize extends Subscribable {
  #observer;
  window = {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
  };

  constructor() {
    super();
    this.#observer = new ResizeObserver(this.handleResize);
    this.#observer.observe(document.body);
  }

  handleResize = (entries) => {
    const entry = entries[0];
    if (!entry) return;

    this.window.innerWidth = window.innerWidth;
    this.window.innerHeight = window.innerHeight;

    this.subs = {
      width: this.window.innerWidth,
      height: this.window.innerHeight,
    };
  };

  observe(element) {
    this.#observer.observe(element);
  }

  unobserve(element) {
    this.#observer.unobserve(element);
  }
}

export class _Raf extends Subscribable {
  time = 0;
  deltaTime = 0;
  frame = 0;

  constructor() {
    super();
    gsap.ticker.add(this.raf);
  }

  raf = (time, deltaTime, frame) => {
    this.time = time;
    this.deltaTime = deltaTime / 1000;
    this.frame = frame;

    this.subs = {
      time,
      deltaTime,
      frame,
    };
  };
}

export const Resize = new _Resize();
export const Raf = new _Raf();
